import { css } from 'linaria';

export const delivMethodsCntrNew = css`
  display: flex;
  flex-direction: column;
`;

export const delivMethodOptNew = css`
  display: block;
  width: 100%;
`;
